import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store";
import "bootstrap/dist/css/bootstrap.min.css";
import { CookiesProvider } from "react-cookie";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GOOGLE_CLIENT_ID } from "./store/constant";
import { GoogleMapsProvider } from "./providers/GoogleMapsProvider";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "./components/ErrorFallback";


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const AppWithUserKeys = () => {

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  );
};


root.render(
  <CookiesProvider>
    <BrowserRouter>
      {/* <React.StrictMode> */}
        <Provider store={store}>
          <GoogleMapsProvider>
            <ErrorBoundary FallbackComponent={ErrorFallback}
              onError={(error: any, info: any) => {
                console.error("Global Error:", error, info);
              }}
              >
              <AppWithUserKeys />
            </ErrorBoundary>
          </GoogleMapsProvider>
        </Provider>
      {/* </React.StrictMode> */}
    </BrowserRouter>
  </CookiesProvider>
);


reportWebVitals();
